module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "ad-block"
  }, [_vm._c('div', {
    class: _vm.containerClass
  }, [_vm._c('div', {
    staticClass: "ad-wrap"
  }, [_vm._c('InArticleAdsense', {
    attrs: {
      "data-ad-client": "ca-pub-4296186765472233",
      "data-ad-slot": "5176485427"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-70ce9fb2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ads/HorizontalAd.vue
// module id = 683
// module chunks = 1